export const parseISODate = (isoStr?: string) => {
  if (!isoStr) return null;
  const datePart = isoStr.split("T")[0]; // Extracts "YYYY-MM-DD"
  const [year, month, day] = datePart.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const getEventColor = (event: any) => {
  const str = String(event.id || event.name || "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs((hash * 137.508) % 360);
  return `hsl(${Math.floor(hue)}, 70%, 42%)`;
};